(function () {
  'use strict';

  const finder = document.getElementById('lf-finder');
  if (!finder) return;

  /* ── State ──────────────────────────────────────────────────── */
  let currentStep    = 1;
  let selectedStyle  = null;   // { title, imageUrlMobile }
  let likedMoods     = [];     // string[]
  let selectedScope  = null;   // { title, imageUrlMobile }
  let selectedBudget = null;   // number (€)
  let selectedIndoor  = [];    // { label, collection }[]
  let selectedOutdoor = [];    // { label, collection }[]
  let firstMoodHintShowTimer = null;
  let firstMoodHintHideTimer = null;
  let firstMoodHintWrap = null;
  let firstMoodHintDismissHandler = null;

  const FIRST_MOOD_HINT_DELAY_MS = 1000;
  const FIRST_MOOD_HINT_DURATION_MS = 10000;

  /* ── DOM refs ───────────────────────────────────────────────── */
  const backBtn       = finder.querySelector('#lf-back-btn');
  const brand         = finder.querySelector('#lf-brand');
  const progressLabel = finder.querySelector('#lf-progress-label');
  const progressPct   = finder.querySelector('#lf-progress-pct');
  const progressFill  = finder.querySelector('#lf-progress-fill');
  const progressTrack = finder.querySelector('.lf-progress-track');
  const progressMeta  = finder.querySelector('.lf-progress-meta');
  const content       = finder.querySelector('#lf-content');
  const allSteps      = Array.from(finder.querySelectorAll('.lf-step'));

  /* ── Helpers ────────────────────────────────────────────────── */
  function getStep(n) {
    return allSteps.find(s => +s.dataset.step === n) || null;
  }

  function setProgress(pct) {
    const p = Math.max(0, Math.min(100, Math.round(pct)));
    progressPct.textContent  = p + '%';
    progressFill.style.width = p + '%';
  }

  function setProgressLabel(text) {
    progressLabel.textContent = text;
  }

  function hideFirstMoodHint() {
    if (firstMoodHintHideTimer) {
      clearTimeout(firstMoodHintHideTimer);
      firstMoodHintHideTimer = null;
    }
    if (firstMoodHintWrap && firstMoodHintDismissHandler) {
      firstMoodHintWrap.removeEventListener('click', firstMoodHintDismissHandler);
    }
    if (firstMoodHintWrap) {
      firstMoodHintWrap.classList.remove('is-showing-hint');
      const hint = firstMoodHintWrap.querySelector('.lf-swipe-hint');
      if (hint) hint.classList.remove('is-visible');
      const stepEl = firstMoodHintWrap.closest('.lf-step');
      stepEl?.querySelectorAll('.lf-mood-btn').forEach(b => (b.disabled = false));
    }
    firstMoodHintWrap = null;
    firstMoodHintDismissHandler = null;
  }

  function clearFirstMoodHintState() {
    if (firstMoodHintShowTimer) {
      clearTimeout(firstMoodHintShowTimer);
      firstMoodHintShowTimer = null;
    }
    hideFirstMoodHint();
  }

  function showFirstMoodHint(wrap) {
    const hint = wrap?.querySelector('.lf-swipe-hint');
    if (!hint || !wrap) return;

    firstMoodHintWrap = wrap;
    wrap.classList.add('is-showing-hint');
    hint.classList.add('is-visible');

    const stepEl = wrap.closest('.lf-step');
    stepEl?.querySelectorAll('.lf-mood-btn').forEach(b => (b.disabled = true));

    firstMoodHintDismissHandler = () => hideFirstMoodHint();
    wrap.addEventListener('click', firstMoodHintDismissHandler, { once: true });
    firstMoodHintHideTimer = setTimeout(hideFirstMoodHint, FIRST_MOOD_HINT_DURATION_MS);
  }

  function scheduleFirstMoodHint(stepEl) {
    const wrap = stepEl.querySelector('.lf-mood-wrap[data-first-mood="true"]');
    if (!wrap?.querySelector('.lf-swipe-hint')) return;

    firstMoodHintShowTimer = setTimeout(() => {
      firstMoodHintShowTimer = null;
      showFirstMoodHint(wrap);
    }, FIRST_MOOD_HINT_DELAY_MS);
  }

  /* Toggle the budget CTA between its two text states */
  function enableCta(stepEl, enabled) {
    const cta = stepEl.querySelector('[data-action="next"]');
    if (!cta) return;
    cta.classList.toggle('is-disabled', !enabled);
    const pre = cta.querySelector('.lf-cta__pre');
    const go  = cta.querySelector('.lf-cta__go');
    if (pre) pre.style.display = enabled ? 'none' : '';
    if (go)  go.style.display  = enabled ? ''     : 'none';
  }

  /* ── Navigation ─────────────────────────────────────────────── */
  function showStep(n) {
    const prevEl = getStep(currentStep);
    const nextEl = getStep(n);
    if (!nextEl) return;

    clearFirstMoodHintState();
    prevEl?.classList.remove('is-active');
    nextEl.classList.add('is-active');
    currentStep = n;
    content.scrollTo({ top: 0, behavior: 'smooth' });
    onEnter(nextEl);
  }

  function goNext() { showStep(currentStep + 1); }

  function goBack() {
    if (currentStep > 1) showStep(currentStep - 1);
    else window.history.back();
  }

  /* ── Step-enter logic ───────────────────────────────────────── */
  function onEnter(stepEl) {
    const type = stepEl.dataset.stepType;
    const hideProgress  = type === 'intro';

    /* Header state: zurück always available; profile also shows the logo */
    if (backBtn) {
      backBtn.style.display = '';
      backBtn.disabled = false;
      backBtn.classList.remove('is-disabled');
    }
    if (brand)   brand.style.display   = type === 'profile' ? 'block' : 'none';

    /* Progress bar: hidden on the intro/start step */
    if (progressTrack) progressTrack.style.display = hideProgress ? 'none' : '';
    if (progressMeta)  progressMeta.style.display  = hideProgress ? 'none' : '';

    switch (type) {

      case 'intro':
        break;

      case 'style':
        setProgressLabel('Dein Lichtprofil');
        setProgress(0);
        break;

      case 'mood':
        setProgressLabel('Dein Lichtprofil');
        setProgress(+stepEl.dataset.progress || 0);
        stepEl.querySelectorAll('.lf-mood-btn').forEach(b => (b.disabled = false));
        stepEl.querySelectorAll('.lf-mood-wrap').forEach(wrap => {
          wrap.classList.remove('is-showing-hint');
          const hint = wrap.querySelector('.lf-swipe-hint');
          if (hint) hint.classList.remove('is-visible');
        });
        scheduleFirstMoodHint(stepEl);
        break;

      case 'budget': {
        setProgressLabel('Dein Lichtprofil');
        /* Restore scope card selection */
        if (selectedScope) {
          stepEl.querySelectorAll('.lf-scope-card').forEach(c =>
            c.classList.toggle('is-selected', c.dataset.value === selectedScope.title)
          );
          setProgress(+(stepEl.dataset.progressComplete || 90));
          enableCta(stepEl, true);
        } else {
          setProgress(+stepEl.dataset.progress || 70);
        }
        break;
      }

      case 'light_type': {
        setProgressLabel('Dein Lichtprofil');
        stepEl.querySelectorAll('.lf-lt-option').forEach(o => {
          const list = o.dataset.group === 'indoor' ? selectedIndoor : selectedOutdoor;
          o.classList.toggle('is-selected', list.some(s => s.label === o.dataset.value));
        });
        updateLightTypeProgress(stepEl);
        updateLightTypeCta(stepEl);
        break;
      }

      case 'profile':
        setProgressLabel('Dein Lichtprofil');
        setProgress(100);
        populateProfile();
        break;

      case 'analysis': {
        const cfg = stepEl.querySelector('.lf-analysis-config');
        const analysisLabel = cfg?.dataset.analysisLabel || 'Analyse Lichtprofil';
        setProgressLabel(analysisLabel);
        setProgress(0);
        if (backBtn) {
          backBtn.disabled = true;
          backBtn.classList.add('is-disabled');
        }
        runAnalysis(stepEl);
        break;
      }
    }
  }

  /* ── Profile population ─────────────────────────────────────── */
  function populateProfile() {
    const byId = id => finder.querySelector('#' + id);

    /* Images from selected cards */
    const styleImgEl = byId('lf-pimg-style');
    const scopeImgEl = byId('lf-pimg-scope');
    if (styleImgEl && selectedStyle?.imageUrlMobile) {
      styleImgEl.style.backgroundImage = `url("${selectedStyle.imageUrlMobile}")`;
    }
    if (scopeImgEl && selectedScope?.imageUrlMobile) {
      scopeImgEl.style.backgroundImage = `url("${selectedScope.imageUrlMobile}")`;
    }

    /* Text values */
    const set = (id, val) => {
      const el = byId(id);
      if (el) el.textContent = val || '—';
    };
    set('lf-rv-style',   selectedStyle?.title);
    set('lf-rv-scope',   selectedScope?.title);
    set('lf-rv-indoor',  selectedIndoor.map(s => s.label).join(', '));
    set('lf-rv-outdoor', selectedOutdoor.map(s => s.label).join(', '));
    if (selectedBudget) set('lf-rv-budget', 'Bis ' + selectedBudget + '€');

    /* Liked moods — one per line */
    const moodEl = byId('lf-rv-mood');
    if (moodEl) {
      moodEl.innerHTML = likedMoods.length
        ? likedMoods.map(m => `<div>${m}</div>`).join('')
        : '<div>—</div>';
    }
  }

  const RESULTS_MATCH_LIMIT    = 6;
  const RESULTS_FALLBACK_LIMIT = 8;

  function resetResultItems() {
    finder.querySelectorAll('.lf-result-item').forEach(item => {
      item.classList.add('is-hidden');
      item.classList.remove('is-visible');
      item.style.display = 'none';
    });
    const noRes = finder.querySelector('.lf-no-results');
    if (noRes) noRes.style.display = 'none';
    setResultsSubheading(false);
  }

  function setResultsSubheading(isFallback) {
    finder.querySelectorAll('.lf-results-sub').forEach(el => {
      const mode = el.dataset.resultsSub;
      el.hidden = isFallback ? mode === 'default' : mode === 'fallback';
    });
    finder.querySelector('[data-phase="results"]')?.classList.toggle('is-fallback', isFallback);
  }

  function sortByCategoryRelevance(items, selectedCols) {
    return items.sort((a, b) => matchScore(b, selectedCols) - matchScore(a, selectedCols));
  }

  function getCategoryProducts(items, selectedCols) {
    return items.filter(item => productMatchesSelections(item, selectedCols));
  }

  function parseColList(str) {
    return (str || '').split(/[\s,]+/).map(s => s.trim()).filter(Boolean);
  }

  function productMatchesSelections(item, selectedCols) {
    if (!selectedCols.length) return false;
    const quizCols = parseColList(item.dataset.quizCollections);
    const allCols  = parseColList(item.dataset.collections);
    return selectedCols.some(col => quizCols.includes(col) || allCols.includes(col));
  }

  function matchScore(item, selectedCols) {
    const quizCols = parseColList(item.dataset.quizCollections);
    const allCols  = parseColList(item.dataset.collections);
    let score = 0;
    selectedCols.forEach(col => {
      if (quizCols.includes(col)) score += 2;
      else if (allCols.includes(col)) score += 1;
    });
    return score;
  }

  /* ── Analysis animation ─────────────────────────────────────── */
  function runAnalysis(stepEl) {
    const analysisPhase = stepEl.querySelector('[data-phase="analysis"]');
    const resultsPhase  = stepEl.querySelector('[data-phase="results"]');
    const rows          = analysisPhase.querySelectorAll('.lf-a-row');
    const cfg           = stepEl.querySelector('.lf-analysis-config');
    const completeLabel = cfg?.dataset.completeLabel || 'Analyse abgeschlossen';

    resetResultItems();

    /* Show analysis phase, hide results */
    if (analysisPhase) analysisPhase.style.display = '';
    if (resultsPhase)  resultsPhase.style.display  = 'none';

    /* Reset all rows */
    rows.forEach(row => {
      row.classList.remove('is-done');
      const fill = row.querySelector('.lf-a-fill');
      const pct  = row.querySelector('.lf-a-row__pct');
      const chk  = row.querySelector('.lf-a-row__check');
      const trk  = row.querySelector('.lf-a-track');
      if (fill) fill.style.width      = '0%';
      if (pct)  { pct.textContent = '0%'; pct.style.display = ''; }
      // if (chk)  chk.style.display     = 'none';
      // if (trk)  trk.style.display     = '';
    });

    const FILL_DURATION = 900;   // ms for each bar to fill
    const ROW_GAP       = 1100;  // ms between row starts

    rows.forEach((row, i) => {
      const fill = row.querySelector('.lf-a-fill');
      const pct  = row.querySelector('.lf-a-row__pct');
      const chk  = row.querySelector('.lf-a-row__check');
      const trk  = row.querySelector('.lf-a-track');

      setTimeout(() => {
        let startTs = null;

        const tick = (ts) => {
          if (!startTs) startTs = ts;
          const elapsed  = ts - startTs;
          const progress = Math.min(elapsed / FILL_DURATION, 1);
          const p        = Math.round(progress * 100);

          if (fill) fill.style.width   = p + '%';
          if (pct)  pct.textContent    = p + '%';

          /* Drive the global progress bar as a fraction of total rows */
          setProgress(((i + progress) / rows.length) * 100);

          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            /* Row complete */
            row.classList.add('is-done');
            if (pct) pct.style.display = 'none';
            // if (chk) chk.style.display = '';
            // if (trk) trk.style.display = 'none';

            /* After last row, flip to results */
            if (i === rows.length - 1) {
              setTimeout(() => {
                setProgress(100);
                setProgressLabel(completeLabel);
                showResults(stepEl);
              }, 700);
            }
          }
        };

        requestAnimationFrame(tick);
      }, i * (FILL_DURATION + ROW_GAP));
    });
  }

  // function showResults(stepEl) {
  //   const analysisPhase = stepEl.querySelector('[data-phase="analysis"]');
  //   const resultsPhase  = stepEl.querySelector('[data-phase="results"]');
  //   if (analysisPhase) analysisPhase.style.display = 'none';
  //   if (resultsPhase)  resultsPhase.style.display  = '';
  //   populateResults();
  //   content.scrollTo({ top: 0, behavior: 'smooth' });
  // }
  function initProductImageSwipers(container) {
    const SwiperCtor = window.Swiper;
    if (!SwiperCtor) return;

    container.querySelectorAll('.lf-result-item.is-visible .product_item_image.swiper').forEach(el => {
      if (el.classList.contains('swiper-initialized')) {
        if (el.swiper) el.swiper.update();
        return;
      }

      new SwiperCtor(el, {
        direction: 'horizontal',
        loop: true,
        effect: 'slide',
        initialSlide: parseInt(el.getAttribute('data-initialSlide'), 10) || 0,
        on: {
          slideChangeTransitionEnd: function () {
            const active = this.el.querySelector('.swiper-slide.swiper-slide-active');
            if (!active) return;
            const variantsMedia = active.getAttribute('data-variants_media');
            if (!variantsMedia || variantsMedia === ' ') return;
            const variantButtons = this.el.closest('.product-item')?.querySelectorAll('.product-item__color-variant');
            if (!variantButtons?.length) return;
            variantButtons.forEach(button => {
              if (variantsMedia.indexOf(button.getAttribute('data-variant-id')) > -1) {
                variantButtons.forEach(b => b.classList.remove('active'));
                button.classList.add('active');
              }
            });
          }
        }
      });
    });
  }

  function showResults(stepEl) {
    const analysisPhase = stepEl.querySelector('[data-phase="analysis"]');
    const resultsPhase  = stepEl.querySelector('[data-phase="results"]');
    if (analysisPhase) analysisPhase.style.display = 'none';
    if (resultsPhase)  resultsPhase.style.display  = '';
    if (backBtn) {
      backBtn.disabled = false;
      backBtn.classList.remove('is-disabled');
    }

    populateResults();
    content.scrollTo({ top: 0, behavior: 'smooth' });

    setTimeout(() => {
      initProductImageSwipers(stepEl);
      window.dispatchEvent(new Event('scroll'));
      window.dispatchEvent(new Event('resize'));
    }, 50);
  }

  /* ── Product results ────────────────────────────────────────── */
  // function populateResults() {
  //   const grid = finder.querySelector('#lf-product-grid');
  //   if (!grid) return;

  //   const pool   = Array.from(finder.querySelectorAll('#lf-product-pool .lf-pool-item'));
  //   const budget = selectedBudget != null ? selectedBudget : Infinity;
  //   const inCol  = selectedIndoor?.collection  || '';
  //   const outCol = selectedOutdoor?.collection || '';

  //   /* Primary filter: collection match + budget */
  //   let matched = pool.filter(item => {
  //     const price = parseFloat(item.dataset.price);
  //     const cols  = (item.dataset.collections || '')
  //       .split(' ').map(s => s.trim()).filter(Boolean);
  //     const inCollection = (!inCol && !outCol) ||
  //       (inCol  && cols.includes(inCol))  ||
  //       (outCol && cols.includes(outCol));
  //     return inCollection && price <= budget;
  //   });

  //   /* Fallback: if nothing matched, show by budget only */
  //   if (!matched.length) {
  //     matched = pool.filter(item => parseFloat(item.dataset.price) <= budget);
  //   }

  //   matched = matched.slice(0, 6);

  //   if (!matched.length) {
  //     grid.innerHTML = '<p class="lf-no-results">Keine passenden Produkte gefunden.</p>';
  //     return;
  //   }

  //   grid.innerHTML = matched.map(item => {
  //     const price   = parseFloat(item.dataset.price);
  //     const compare = parseFloat(item.dataset.compare);
  //     const hasDiscount = compare > 0 && compare > price;
  //     return `
  //       <a href="${item.dataset.url}" class="lf-product-card">
  //         <div class="lf-product-card__img">
  //           <img src="${item.dataset.image}" alt="${item.dataset.title}" loading="lazy">
  //         </div>
  //         <div class="lf-product-card__info">
  //           <span class="lf-product-card__title">${item.dataset.title}</span>
  //           <div class="lf-product-card__prices">
  //             ${hasDiscount ? `<span class="lf-product-card__compare">${compare}€</span>` : ''}
  //             <span class="lf-product-card__price">${price}€</span>
  //           </div>
  //         </div>
  //       </a>`;
  //   }).join('');
  // }
  function getSelectedCollectionHandles() {
    return [
      ...selectedIndoor.map(s => s.collection),
      ...selectedOutdoor.map(s => s.collection)
    ].filter(Boolean);
  }

  function updateLightTypeProgress(stepEl) {
    if (selectedIndoor.length || selectedOutdoor.length) {
      setProgress(+(stepEl.dataset.progressComplete || 95));
    } else {
      setProgress(+stepEl.dataset.progress || 90);
    }
  }

  function updateLightTypeCta(stepEl) {
    const cta = stepEl?.querySelector('[data-action="next"]');
    if (!cta) return;
    const hasSelection = selectedIndoor.length > 0 || selectedOutdoor.length > 0;
    const defaultLabel = cta.dataset.ctaDefault || cta.textContent.trim();
    const activeLabel  = cta.dataset.ctaActive || defaultLabel;
    cta.textContent = hasSelection ? activeLabel : defaultLabel;
    cta.classList.toggle('is-disabled', !hasSelection);
  }

	function populateResults() {
		const items  = Array.from(finder.querySelectorAll('.lf-result-item'));
		const noRes  = finder.querySelector('.lf-no-results');
		const budget = selectedBudget != null ? selectedBudget : Infinity;
		const selectedCols = getSelectedCollectionHandles();

		function setItemVisible(item, visible) {
			item.classList.toggle('is-hidden', !visible);
			item.classList.toggle('is-visible', visible);
			item.style.display = visible ? 'contents' : 'none';
		}

		items.forEach(item => setItemVisible(item, false));
		if (noRes) noRes.style.display = 'none';
		setResultsSubheading(false);

		if (!selectedCols.length) {
			if (noRes) noRes.style.display = '';
			return;
		}

		const inCategory = getCategoryProducts(items, selectedCols);
		const matched = sortByCategoryRelevance(
			inCategory.filter(item => {
				const price = parseFloat(item.dataset.price);
				return !Number.isNaN(price) && price <= budget;
			}),
			selectedCols
		);

		if (matched.length) {
			matched.slice(0, RESULTS_MATCH_LIMIT).forEach(item => setItemVisible(item, true));
			return;
		}

		/* Fallback: bestsellers from selected Leuchtenart (collection order, no budget filter) */
		const fallback = sortByCategoryRelevance(inCategory, selectedCols)
			.slice(0, RESULTS_FALLBACK_LIMIT);

		setResultsSubheading(true);

		if (fallback.length) {
			fallback.forEach(item => setItemVisible(item, true));
		} else if (noRes) {
			noRes.style.display = '';
		}
	}

  /* ── Shared mood-card fly-out ───────────────────────────────── */
  function flyMoodCard(wrap, liked) {
    if (!wrap) { goNext(); return; }
    const flyX  = (liked ? 1 : -1) * (wrap.offsetWidth + 40);
    const flyRot = liked ? 18 : -18;
    wrap.style.transition = 'transform 0.32s ease';
    wrap.style.transform  = `translateX(${flyX}px) rotate(${flyRot}deg)`;
    setTimeout(() => {
      wrap.style.transition = '';
      wrap.style.transform  = '';
      goNext();
    }, 300);
  }

  /* ── Track last pointer type (mouse vs touch) ──────────────── */
  let lastPointerType = 'mouse';
  finder.addEventListener('pointerdown', e => { lastPointerType = e.pointerType; });

  /* ── Event delegation ───────────────────────────────────────── */
  finder.addEventListener('click', e => {
    const btn = e.target.closest('[data-action]');
    if (!btn || btn.classList.contains('is-disabled')) return;

    const action = btn.dataset.action;
    const stepEl = btn.closest('.lf-step');

    switch (action) {

      /* ── Generic next ── */
      case 'next':
        goNext();
        break;

      /* ── Style card ── */
      case 'select-style':
        stepEl?.querySelectorAll('.lf-style-card').forEach(c => c.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        selectedStyle = { 
					title: btn.dataset.value, 
					imageUrlMobile: btn.dataset.imgMobile || '' 
        };
        setTimeout(goNext, 380);
        break;

      /* ── Mood ❌ / ❤️ ── */
      case 'mood-action': {
        const liked = btn.dataset.liked === 'true';
        if (liked) {
          const title = btn.dataset.moodTitle?.trim();
          if (title && !likedMoods.includes(title)) likedMoods.push(title);
        }
        if (firstMoodHintWrap) return;
        if (lastPointerType === 'touch') {
          const wrap = stepEl?.querySelector('.lf-mood-wrap');
          flyMoodCard(wrap, liked);
        } else {
          goNext();
        }
        break;
      }

      /* ── Scope card ── */
      case 'select-scope':
        stepEl?.querySelectorAll('.lf-scope-card').forEach(c => c.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        selectedScope = { title: btn.dataset.value, imageUrlMobile: btn.dataset.imgMobile || '' };
        setProgress(+(stepEl?.dataset.progressComplete || 90));
        enableCta(stepEl, true);
        break;

      /* ── Light-type option (multi-select per group, toggle) ── */
      case 'select-lt': {
        const group = btn.dataset.group;
        const isSelected = btn.classList.contains('is-selected');
        const entry = {
          label: btn.dataset.value,
          collection: btn.dataset.collection || ''
        };
        const list = group === 'indoor' ? selectedIndoor : selectedOutdoor;

        if (isSelected) {
          const idx = list.findIndex(s => s.label === entry.label);
          if (idx > -1) list.splice(idx, 1);
          btn.classList.remove('is-selected');
        } else {
          list.push(entry);
          btn.classList.add('is-selected');
        }

        updateLightTypeProgress(stepEl);
        updateLightTypeCta(stepEl);
        break;
      }
    }
  });

  /* ── Back button ────────────────────────────────────────────── */
  if (backBtn) backBtn.addEventListener('click', () => {
    if (backBtn.disabled) return;
    goBack();
  });

  /* ── Swipe gesture on mood cards ───────────────────────────── */
  finder.querySelectorAll('.lf-mood-wrap').forEach(wrap => {
    let startX = 0, startY = 0, deltaX = 0;
    let active = false, dirLocked = null; // null | 'h' | 'v'
    const SWIPE_THRESHOLD = 60;

    wrap.addEventListener('touchstart', e => {
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      deltaX = 0;
      active = true;
      dirLocked = null;
    }, { passive: true });

    wrap.addEventListener('touchmove', e => {
      if (!active) return;
      const t = e.touches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      if (dirLocked === null && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        dirLocked = Math.abs(dx) >= Math.abs(dy) ? 'h' : 'v';
      }

      if (dirLocked !== 'h') return;

      e.preventDefault();
      deltaX = dx;
      wrap.style.transition = 'none';
      wrap.style.transform = `translateX(${deltaX}px) rotate(${deltaX * 0.03}deg)`;
    }, { passive: false });

    function endSwipe() {
      if (!active) return;
      active = false;

      if (dirLocked !== 'h' || Math.abs(deltaX) < SWIPE_THRESHOLD) {
        wrap.style.transition = 'transform 0.25s ease';
        wrap.style.transform = '';
        wrap.addEventListener('transitionend', () => { wrap.style.transition = ''; }, { once: true });
        deltaX = 0;
        return;
      }

      const liked = deltaX > 0;
      const stepEl = wrap.closest('.lf-step');

      if (firstMoodHintWrap) {
        hideFirstMoodHint();
        wrap.style.transition = 'transform 0.25s ease';
        wrap.style.transform = '';
        deltaX = 0;
        return;
      }

      if (liked) {
        const likeBtn = stepEl?.querySelector('.lf-mood-btn[data-liked="true"]');
        const title = likeBtn?.dataset.moodTitle?.trim();
        if (title && !likedMoods.includes(title)) likedMoods.push(title);
      }

      flyMoodCard(wrap, liked);
      deltaX = 0;
    }

    wrap.addEventListener('touchend', endSwipe);
    wrap.addEventListener('touchcancel', endSwipe);
  });

  /* ── Initialise first step ──────────────────────────────────── */
  onEnter(getStep(1));

})();
